module.exports = __webpack_public_path__ + "img/progress-bg.38b5989.png";